import React from 'react'
import EtablissementsGroupe from '../../Component/Etablissement/EtablissementsGroupe'
import Utilisateur from '../../Component/Etablissement/Utilisateur'
import Regroupement from '../../Component/Etablissement/Regroupement/'
import Profil from '../../Component/Etablissement/Profil'
import Grid from '@material-ui/core/Grid/Grid'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'


export default (class extends React.Component {

  state = {
    UserTabSelected: 1,
    busGUID: Utils.uuidv4()
  }

  crmConfiguration = {
    1: {
      component: <Utilisateur/>,
    },
    2: {
      component: <EtablissementsGroupe/>,
    },
    3: {
      component: <Profil/>
    },
    4: {
      component: <Regroupement/>,
    },
  }


  componentWillUnmount () {
    Bus.$off('donnees_annexes_etablissement', this.state.busGUID)
  }

  componentDidMount () {
    Bus.$on('donnees_annexes_etablissement', id => {
      this.setState({ UserTabSelected: id })
    }, this.state.busGUID)
  }

  render () {
    return <Grid container style={{ margin: 0, padding: 0, width: '100%' }} spacing={0}>
      <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
        {
          this.crmConfiguration[this.state.UserTabSelected].component
        }
      </Grid>
    </Grid>
  }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/Etablissement/index.js